import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByAlphabet } from '@app/comparers';

import {
  UserBusinessActionTypes,
  UserBusinessActionsUnion
} from '@core/actions/user-business.actions';
import * as fromRoot from '@core/reducers/root.reducer';
import { UserBusiness } from '@app/models/user-business';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<UserBusiness> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<UserBusiness> = createEntityAdapter<UserBusiness>({
  selectId: (userBusiness: UserBusiness) => userBusiness.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});


export function reducer(
  state: State = INITIAL_STATE,
  action: UserBusinessActionsUnion
) {
  switch (action.type) {
    case  UserBusinessActionTypes.Load:
      return { ...state, loading: true };

    case UserBusinessActionTypes.LoadFail:
      return { ...state, loading: false };

    case UserBusinessActionTypes.LoadSuccess:
      return adapter.addAll(action.userBusinesses, {
        ...state,
        loading: false,
        loaded: true
      });
      
    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();


export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getState = createFeatureSelector<State>('userBusinesses');
export const getUserBusinesses = createSelector(
  getState,
  selectAll
);
